module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "trialPage mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm10": "",
      "md10": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 mb-4 text-xs-center trialtitle"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: _vm.enrollmentsss.enrollmentName
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.trial.trialName))])]), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('document-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Description")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white pl-4 pr-4"
  }, [_c('pre', {
    staticClass: "textDescription"
  }, [_vm._v(_vm._s(_vm.trial.trialDescription))])]), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('person-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Coordinators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white pa-2"
  }, [_c('v-list', _vm._l((_vm.coordinatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.coordinatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.coordinatorPhone
      }
    }, [_c('phoneIcon', {
      staticClass: "icon"
    })], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.coordinatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.coordinatorEmail + '?subject=' + _vm.trial.trialName
      }
    }, [_c('emailIcon', {
      staticClass: "icon"
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('investigator-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Investigators")], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white pa-2"
  }, [_c('v-list', _vm._l((_vm.investigatorsGetter), function(item, index) {
    return _c('v-list-tile', {
      key: ("item-" + index)
    }, [_c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.investigatorName) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'tel:' + item.investigatorPhone
      }
    }, [_c('phone-icon', {
      staticClass: "icon"
    })], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'sms:' + item.investigatorPhone
      }
    }, [_c('v-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey lighten-2'
      }
    }, [_vm._v("textsms")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "href": 'mailto:' + item.investigatorEmail + '?subject=' + _vm.trial.trialName + '&body=Name: <br>Tel: <br>Email: '
      }
    }, [_c('email-icon', {
      staticClass: "icon"
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('map-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Address")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item) {
    return _c('v-card-text', {
      key: item.locationID,
      staticClass: "white pl-4 pr-4"
    }, [_c('strong', [_vm._v(_vm._s(item.locationName))]), _c('br'), _vm._v("\n              " + _vm._s(item.locationStreetAddress)), _c('br'), _vm._v("\n              " + _vm._s(item.locationCity) + ", " + _vm._s(item.locationState) + " " + _vm._s(item.locationZipcode) + "\n            ")])
  }), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('map-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Location")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.locationsss), function(item, index) {
    return (_vm.trial.trialLocations) ? _c('v-card-text', {
      key: ("item-" + index),
      staticClass: "white pl-4 pr-4"
    }, [_vm._v("\n              " + _vm._s(item.locationName)), _c('br')]) : _vm._e()
  }), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "trialData"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('indication-icon', {
    staticClass: "icon mr-2"
  }), _vm._v("Indications")], 1), _vm._v(" "), _c('v-card', [_vm._l((_vm.indicationsss), function(item, index) {
    return _c('v-card-text', {
      key: ("item-" + index),
      staticClass: "white pl-4 pr-4"
    }, [_vm._v("\n            " + _vm._s(item.indicationName)), _c('br')])
  }), _vm._v(" "), _c('v-divider')], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-4 cyan--text text--darken-3",
    attrs: {
      "depressed": "",
      "color": "cyan lighten-5",
      "dark": "",
      "href": _vm.trial.trialLink,
      "target": "_blank"
    }
  }, [_vm._v("ClinicalTrials.gov")]), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-btn', {
    staticClass: "mt-4 cyan--text text--darken-3",
    attrs: {
      "depressed": "",
      "color": "cyan lighten-5",
      "dark": "",
      "to": '/trials/' + _vm.trial.trialId + '/edit'
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a2e4d15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Trial.vue
// module id = 672
// module chunks = 1